import React from 'react'

const MovieDescriptionAccess = ({
    description,
    descriptionShort,
}) => {
    if(!description && !descriptionShort) {
        return ''
    }


    return (
        <>
            <dt>Beschreibung:</dt>
            <dd>{description ? description : descriptionShort}</dd>
        </>
    )
}

export default MovieDescriptionAccess